import React, { FunctionComponent } from 'react';
import cn from 'classnames';

export interface FormGroupProps {
  name: string;
  label?: string | JSX.Element;
  error?: string | JSX.Element;
  touched?: boolean;
  className?: string;
  displayError?: boolean;
  isRequired?: boolean;
}

const FormGroup: FunctionComponent<FormGroupProps> = ({
  name,
  label,
  error,
  touched,
  className,
  displayError = true,
  children,
  isRequired = false,
}) => {
  const isErrored = (touched ?? true) && (error ?? false);
  return (
    <div
      className={cn(
        'jg-form-group',
        isErrored ? 'jg-form-group-error' : '',
        className ?? '',
      )}
    >
      <label className="jg-form-label" htmlFor={name}>
        {label}
        {isRequired && label ? '*' : ''}
        {children}
        {displayError && isErrored ? (
          <span className="jg-form-error-copy" role="alert">
            {error}
          </span>
        ) : null}
      </label>
    </div>
  );
};

export default FormGroup;
